import PropTypes from 'prop-types';

const Item = PropTypes.shape({
  itemName: PropTypes.string,
  name: PropTypes.string,
});

export default Item;
